export default __webpack_public_path__ + "static/media/levers.59f7f5ee.webp";